import { DashboardLayout } from '@/components/Dashboard/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useRPLStats } from '@/hooks/useRPL';
import { IncidentList } from '@/components/RPL/Incidents/IncidentList';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ArrowLeft, TrendingDown, Clock, CheckCircle } from 'lucide-react';

export default function RPLIncidents() {
  const navigate = useNavigate();
  const { data: stats } = useRPLStats();

  const kpis = [
    {
      title: 'Incidentes este ano',
      value: stats?.total_incidents_year || 0,
      icon: AlertTriangle,
      color: 'text-muted-foreground',
    },
    {
      title: 'Abiertos',
      value: stats?.open_incidents || 0,
      icon: Clock,
      color: stats?.open_incidents ? 'text-red-500' : 'text-green-500',
    },
    {
      title: 'Criticos activos',
      value: stats?.critical_incidents || 0,
      icon: AlertTriangle,
      color: stats?.critical_incidents ? 'text-red-500' : 'text-green-500',
    },
    {
      title: 'Dias perdidos',
      value: stats?.total_days_lost || 0,
      icon: TrendingDown,
      color: 'text-orange-500',
    },
  ];

  return (
    <DashboardLayout>
      <div className="space-y-6 p-6">
        {/* Header */}
        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate('/rpl')}>
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <div>
            <h1 className="text-3xl font-bold bg-gradient-magma bg-clip-text text-transparent flex items-center gap-2">
              <AlertTriangle className="w-8 h-8 text-red-500" />
              Gestion de Incidentes
            </h1>
            <p className="text-muted-foreground mt-1">
              Registro y seguimiento de incidentes de seguridad
            </p>
          </div>
        </div>

        {/* KPIs */}
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {kpis.map((kpi, index) => (
            <Card key={index}>
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-muted-foreground">{kpi.title}</p>
                    <p className={`text-2xl font-bold ${kpi.color}`}>{kpi.value}</p>
                  </div>
                  <kpi.icon className={`w-5 h-5 ${kpi.color}`} />
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Days without incident highlight */}
        <Card className="bg-gradient-to-r from-green-500/10 to-emerald-500/10 border-green-500/20">
          <CardContent className="p-6">
            <div className="flex items-center gap-4">
              <div className="p-4 rounded-full bg-green-500/20">
                <CheckCircle className="w-8 h-8 text-green-500" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground">Dias sin accidentes graves</p>
                <p className="text-4xl font-bold text-green-500">
                  {stats?.days_without_serious_incident || 0}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Incident List */}
        <Card>
          <CardHeader>
            <CardTitle>Listado de Incidentes</CardTitle>
          </CardHeader>
          <CardContent>
            <IncidentList />
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}
